import React from 'react';
import { PublicDateTime } from '@components/PublicDateTime';
import { getFormattedLocalDateTime } from '@helpers/dates';
import { blogCardStyle as classes } from './BlogCardStyle';
import { Text } from '@web-for-marketing/react-ui';
import { LanguageCode } from '@models/languageCode';
import { getTranslation } from '@helpers/languageTranslations';
import { useTranslation } from '@stateManagement/TranslationContext';

interface DateAndReadTimeProps {
    publishedDateUtc: string;
    selectedLanguage: LanguageCode | undefined;
    readMinutes?: number;
}

export function DateAndReadTime({
    publishedDateUtc,
    selectedLanguage,
    readMinutes,
}: DateAndReadTimeProps): React.ReactElement {
    const { selectedLanguageTranslation } = useTranslation();

    const readMinuteText = getTranslation(selectedLanguageTranslation, 'blogInfo', 'readMinutes').replace(
        '5',
        readMinutes ? readMinutes : '~1'
    );

    return (
        <div css={classes.timeBlock}>
            <PublicDateTime>
                <Text variant='body2' color='activeSecondary'>
                    {getFormattedLocalDateTime(publishedDateUtc, 'LL', selectedLanguage)}
                </Text>
            </PublicDateTime>
            <div aria-hidden css={classes.divider}>
                &#124;
            </div>
            {readMinutes ? (
                <Text variant='body2' color='activeSecondary' css={classes.readMinutes}>
                    <span>{readMinuteText}</span>
                </Text>
            ) : null}
        </div>
    );
}
